import { Component, EventEmitter, Output } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { objectPopupScreenService } from 'src/app/shared/services/object-popup-screen';

@Component({
    selector: 'app-input-cell-renderer',
    template: `
    <input 
      type="text" 
      [(ngModel)]="inputValue" 
      (blur)="onBlur()" 
      style="width: 100%;  height: 35px; border: none; outline: none; background-color: transparent;"
    />
  `,
    standalone: false
})
export class InputCellRendererComponent implements ICellRendererAngularComp {
  inputValue: string = "";
  @Output() valueChanged = new EventEmitter<string>(); // Event emitter for input value
  params: any;

  constructor(public objectSvc: objectPopupScreenService) { }

  agInit(params: any): void {
    this.inputValue = params.value;
    this.params = params;
  }

  refresh(params: any): boolean {
    return false;
  }

  onBlur(): void {
    this.valueChanged.emit(this.inputValue); // Emit the input value
    console.log(this.inputValue, this.params.data.id)
    console.log(this.params.data)
    this.params.edit(this.inputValue, this.params.data.id);

    this.params.data[this.params.column.colId] = this.inputValue; // Update cell value
    this.params.api.refreshCells({ rowNodes: [this.params.node], force: true }); // Refresh cell
  }
}
